import { Controller } from "@hotwired/stimulus";

/** Decline submit stays disabled until trimmed reason is non-empty. */
export default class extends Controller {
  static targets = ["reason", "submitButton"];

  connect() {
    this.sync();
  }

  sync() {
    if (!this.hasReasonTarget || !this.hasSubmitButtonTarget) return;

    const ok = this.reasonTarget.value.trim().length > 0;
    this.submitButtonTarget.disabled = !ok;
    this.submitButtonTarget.setAttribute("aria-disabled", ok ? "false" : "true");
  }
}
